module.exports = "<div class=\"evtBiblRef\" compile=\"vm.getFormattedBibl()\">\n</div>\n";